import {get} from 'svelte/store';
import {goto} from '@sapper/app';
import {parse, stringify} from 'query-string';
import {fixLink$} from '@/store/lang';
import {SERVICES} from '@/const/services';
import {PATHS} from '@/const/paths';

export const fullImageUrlFun = (prefix = '/pubimg/') => {
  return (url) => {
    return url ? `${SERVICES.STATIC_URL}${prefix}${url}` : '';
  };
};

export function getLocationSeachParam(key: string): string | null {
  try {
    const search = decodeURIComponent(window.location.search);
    const searchParams = new URLSearchParams(search);
    let value = searchParams.get(key);

    if (key === 'target' && !value) {
      value = sessionStorage.getItem('phemex_redirect_target');
    }
    return value;
  } catch (error) {
    console.error('Error processing URL search params or session storage:', error);
    return null;
  }
}

/**
 *
 * @param {{ pathName: string; searchParams?: Record<string, any>}} params
 * @param {{  useReplace: boolean }} [options]
 */
export function gotoPage(params, options) {
  const {pathName, searchParams} = params;
  const fixLink = get(fixLink$);

  const path = fixLink(pathName);
  const search = searchParams && Object.keys(searchParams).length > 0 ? `?${stringify(searchParams)}` : '';
  const url = `${path}${search}`;

  if (options && options.useReplace) {
    window.location.replace(url);
    return;
  }
  window.location.assign(url);
}

export function getFixedLinkUrl(pathName) {
  const fixLink = get(fixLink$);
  const path = fixLink(pathName);
  return path;
}

export function getFixedLinkFullUrl(pathName) {
  const path = getFixedLinkUrl(pathName);
  if (typeof window === 'object') {
    return `${window.location.origin}${path}`;
  }
  return path;
}

export function getCurrentSearchParams() {
  try {
    const search = decodeURIComponent(window.location.search);
    const searchParams = new URLSearchParams(search);
    return Object.fromEntries(searchParams) || {};
  } catch (error) {
    return {};
  }
}

export function genParamsUrl(pathName, params = {}) {
  const fixLink = get(fixLink$);

  const path = fixLink(pathName);
  const search = params && Object.keys(params).length > 0 ? `?${stringify(params)}` : '';
  return `${path}${search}`;
}

// 为有重定向逻辑的页面生成重定向参数
// customTarget: 可选，自定义跳转目标，不传则默认跳转回当前页
//
// Test Case:
// 生成重定向参数，并需要保留原始参数
// 1. 跳转登录注册带上重定向参数，保留原有参数
//  x/?umt_a=a => register/?target=newtarget&action=Target&umt_a=a
// 2. 已经有 target 的复用 target（避免多次跳转，target越来越长）
//  x/?target=target&action=Target&umt_a=a => register/?target=target&action=Target&umt_a=a
// 3. 自定义 target（跳转到其他页不是跳回当前页）
//  x/?target=target&action=Target&umt_a=a => register/?target=customTarget&action=Target&umt_a=a
export function genRedirectTarget(customTarget?: string) {
  const o = parse(location.search);
  let target = '';
  if (customTarget) {
    target = customTarget;
  } else if (o?.action?.toLowerCase() === 'target' && o?.target) {
    target = o?.target as string;
  } else {
    target = location.href;
  }

  return {
    ...o,
    target,
    action: 'Target',
  };
}

function gotoRedirectPage(page: string, fixLink: any, customTarget?: string) {
  const query = genRedirectTarget(customTarget);
  goto(fixLink(page) + '?' + stringify(query));
}

export function gotoLoginWithRedirect(fixLink: any) {
  goto(fixLink(PATHS.LOGIN.pathname));
}

export function gotoRegisterWithRedirect(fixLink: any) {
  goto(fixLink(PATHS.REGISTER.pathname));
}
